// removed by extract-text-webpack-plugin
module.exports = {"sideBySideInputs":"styles__sideBySideInputs__2fww9","halfWidth":"styles__halfWidth__1kh7B","oneThird":"styles__oneThird__2mHPw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PdfResizer/styles.scss
// module id = 899
// module chunks = 0